import { environment } from './utils';

interface iAnalytics {
  type: string;
  payload: Record<string, unknown>;
}

interface LinkTag {
  fieldErrors?: string;
  siteErrors?: string;
  bannerClicked?: string;
  events?: string;
}

interface ViewTag {
  pageName?: string;
  pageCategory?: string;
  bannerName?: string;
  bannerDisplayed?: string;
}

let analyticsData: iAnalytics;

const triggerEvent = (data: iAnalytics) => {
  const event = new CustomEvent('cvsAnalyticsEvent', { detail: data });
  document.dispatchEvent(event);
};

export const onAnalyticsReady = (): Promise<void> => {
  /* istanbul ignore else  */
  if (environment.envName === 'local') {
    return Promise.resolve();
  }
  /* istanbul ignore next  */
  return window.customElements.whenDefined('cvs-analytics').then(() => {});
};

export const triggerLinkTag = (linkName: string, tagObject: LinkTag = {}) => {
  analyticsData = {
    type: 'link',
    payload: {
      link_name: linkName,
      field_errors: tagObject.fieldErrors,
      site_errors: tagObject.siteErrors,
      bannerClicked: tagObject.bannerClicked,
      events: tagObject.events,
    },
  };
  return onAnalyticsReady().then(() => triggerEvent(analyticsData));
};

export const triggerViewTag = (tagObject: ViewTag): Promise<void> => {
  analyticsData = {
    type: 'view',
    payload: {
      page_name: tagObject.pageName,
      page_category: tagObject.pageCategory,
      banner_name: tagObject.bannerName,
      banner_displayed: tagObject.bannerDisplayed,
    },
  };
  return onAnalyticsReady().then(() => triggerEvent(analyticsData));
};
